import JsBarcode from "jsbarcode";

// A standalone word followed by a number; reject embedded words and suffixes
// such as "Magazinschubladen". The drawer rule takes precedence over Zone.
const DRAWER_NUMBER = /(^|[^\p{L}\p{N}])magazinschublade[\s-]*(\d+)(?![\p{L}\p{N}])/iu;

export function drawerNumber(name) {
    return String(name || "").match(DRAWER_NUMBER)?.[2] ?? null;
}

function crc32(bytes) {
    let crc = 0xffffffff;
    for (const byte of bytes) {
        crc ^= byte;
        for (let bit = 0; bit < 8; bit += 1) crc = (crc >>> 1) ^ ((crc & 1) ? 0xedb88320 : 0);
    }
    return (crc ^ 0xffffffff) >>> 0;
}

// Canvas PNG defaults to 96 dpi. Replace pHYs so label software knows the
// physical size. PNG stores pixels per metre, with CRC over type and data.
export function pngAtDpi(dataUrl, dpi) {
    const source = Uint8Array.from(atob(dataUrl.split(",")[1]), char => char.charCodeAt(0));
    const view = new DataView(source.buffer);
    const chunk = new Uint8Array(21);
    const target = new DataView(chunk.buffer);
    target.setUint32(0, 9);
    chunk.set([112, 72, 89, 115], 4); // pHYs
    target.setUint32(8, Math.round(dpi / 0.0254));
    target.setUint32(12, Math.round(dpi / 0.0254));
    chunk[16] = 1;
    target.setUint32(17, crc32(chunk.slice(4, 17)));
    const parts = [source.slice(0, 8)];
    for (let offset = 8; offset < source.length;) {
        const length = view.getUint32(offset) + 12;
        const type = String.fromCharCode(...source.slice(offset + 4, offset + 8));
        if (type !== "pHYs") parts.push(source.slice(offset, offset + length));
        if (type === "IHDR") parts.push(chunk);
        offset += length;
    }
    return `data:image/png;base64,${btoa(parts.map(part => Array.from(part, byte => String.fromCharCode(byte)).join("")).join(""))}`;
}

export function renderDrawerBarcode(number, scanNumber) {
    if (!/^F\d{6}$/.test(scanNumber || "")) {
        throw new Error("Scan-Nummer fehlt. Bitte die Fachliste neu laden.");
    }
    const dpi = 300;
    const height = Math.round(10 / 25.4 * dpi);
    const barcode = document.createElement("canvas");
    // Integer pixels and 10-module quiet zones keep the narrow bars readable.
    JsBarcode(barcode, scanNumber, {
        format: "CODE128", width: 4, height: height - 12,
        displayValue: false, margin: 0, marginLeft: 40, marginRight: 40,
        background: "#ffffff", lineColor: "#000000",
    });
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    if (!ctx) throw new Error("Bild konnte nicht erzeugt werden.");
    ctx.font = "700 96px Arial, sans-serif";
    const numberWidth = Math.ceil(ctx.measureText(number).width) + 12;
    canvas.width = numberWidth + barcode.width;
    canvas.height = height;
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, canvas.width, height);
    ctx.fillStyle = "#000000";
    ctx.font = "700 96px Arial, sans-serif";
    ctx.textBaseline = "middle";
    ctx.fillText(number, 6, height / 2);
    ctx.drawImage(barcode, numberWidth, 6);
    return { dataUrl: pngAtDpi(canvas.toDataURL("image/png"), dpi), width: canvas.width, height, dpi };
}
